import { ReactElement } from "react";
import { Link } from "react-router";

export type TrendingTopicItem = {
  label: string;
  href?: string;
};

type TrendingTopicsProps = {
  title?: string;
  topics: TrendingTopicItem[];
};

export default function TrendingTopics({
  title = "Trending Topics",
  topics,
}: TrendingTopicsProps): ReactElement | null {
  if (!topics.length) {
    return null;
  }

  return (
    <section className="w-full" aria-label={title}>
      <h2 className="text-blue-400 text-sm font-primary font-semibold leading-[24px] mb-xs pl-xxs">
        {title}
      </h2>
      <div className="flex flex-wrap gap-3">
        {topics.map(({ label, href }) => {
          const key = href ?? label.trim().toLowerCase().replace(/\s+/g, "-");
          const chipClassName =
            "inline-flex items-center bg-[#D9D9D9] text-[#4F4F4F] text-sm leading-[1.2] px-4 py-[9px]";

          if (href) {
            return (
              <Link
                key={key}
                to={href}
                className={chipClassName}
                aria-label={`Go to trending topic ${label}`}
              >
                {label}
              </Link>
            );
          }

          return (
            <span key={key} className={chipClassName}>
              {label}
            </span>
          );
        })}
      </div>
    </section>
  );
}
